import { render, staticRenderFns } from "./HomeLowStock.vue?vue&type=template&id=56b85b72&scoped=true&"
import script from "./HomeLowStock.vue?vue&type=script&lang=js&"
export * from "./HomeLowStock.vue?vue&type=script&lang=js&"
import style0 from "./HomeLowStock.vue?vue&type=style&index=0&id=56b85b72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b85b72",
  null
  
)

export default component.exports